import { chunkArrayInGroups } from "@/helpers/generalHelper";
import { sendProductListViewEvent } from "@/helpers/psykheHelper";
import { getCookie } from "cookies-next";
import { useRouter } from "next/compat/router";
import React, { useEffect, useState } from "react";
import { useInfiniteHits } from "react-instantsearch";
import { useSelector } from "react-redux";

export function InjectedInfiniteHits({ slots, hitComponent, position1, position2, currentPage, isRequestingFromMobile, totalFetchedProducts, enableContentTile, isOnlyMobile }) {
  //sendEvent is used to send the click events to algolia for search tracking
  const { results, showMore, isLastPage, hits: totalFetchedSoFar, sendEvent} = useInfiniteHits();
  // determining if the current page is first page or not
  const isFirstPage = currentPage === 1 || totalFetchedSoFar <= (isOnlyMobile ? 50 : 100) ? true : false;

  // if page is requested from the mobile devices, use the {totalFetchedSoFar} else only use the page specific products
  const hits = isRequestingFromMobile && [...totalFetchedSoFar]?.length > 0 ? [...totalFetchedSoFar] : [...results.hits]
  // specifying the positions to add custom content tiles
  let inject1 = position1;
  let inject2 = position2;

  const router = useRouter();
  // Save scroll position before navigation (Next.js route change)
  // Use browser's native scroll restoration if available
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  // show content tiles only if its a first page
  if (isFirstPage && enableContentTile && (hits.length>position1)) {
    hits.splice(inject1, 0, {});
  }

  if (isFirstPage && enableContentTile && (hits.length>position2)) {
    hits.splice(inject2, 0, {});
  }

  // getting the index name of the collection
  const indexName = results.index;


  // Group results by index name for easier access
  const resultsByIndex = { [indexName]: { ...results, hits } };

  // Loop through main hits and inject slots
  const injectedHits = hits
    .map((hit, position) => {
      // Wrap main hits and injected hits into a common format
      // for easier templating
      const hitFromMainIndex = {
        type: "item",
        props: { hit },
        Hit: hitComponent
      };

      return slots({ resultsByIndex })
        .reverse()
        .reduce(
          (acc, { injectAt, getHits = () => [null], slotComponent }) => {
            const slotScopeProps = { position, resultsByIndex };
            const shouldInject =
              typeof injectAt === "function"
                ? injectAt({
                  ...slotScopeProps,
                  hit
                })
                : position === injectAt;


            if (!shouldInject || !isFirstPage) {
              return acc;
            }

            const hitsFromSlotIndex = getHits({ ...slotScopeProps, hit });

            // Merge injected and main hits
            return [
              ...hitsFromSlotIndex.map((hitFromSlotIndex) => ({
                type: "injected content-tile-plp auto-contentTile-plp",
                props: {
                  ...slotScopeProps,
                  hit: hitFromSlotIndex
                },
                Hit: slotComponent
              })),
              ...acc.slice(0, hits) // my changes
            ];
          },
          [hitFromMainIndex]
        );
    })
    .flat();

  //OS-3080 : product list performance tracking
  const [isClient, setDataLayer] = useState(false);
  const logUser = useSelector((state) => state.loginUser);
  useEffect(() => {
    setDataLayer(true);
  },[] )

  const getProductList = () => {
    var productArr = [];
    injectedHits.map(({ props }, index) => {
      //create products array of products listed on page load
      if (props?.hit?.id) {
        productArr.push(
          {
            id: props.hit.id,
            name: props.hit.title,
            price: props.hit.price,
            brand: props.hit.vendor,
            variant: props.hit.variant_title,
            list: router.asPath,
            position: index
          }
        );
      }
    })
    return productArr;
  }

  const sendImpression=()=>{
    var productArr =  getProductList();
    let collectionName = location.href;
    let recoId = getCookie("recoId")
    if (productArr.length > 0) {
      dataLayer.push({ ecommerce: null });
        dataLayer.push({
            'event': 'ProductImpressions',
            'ecommerce': {
            'currencyCode': 'USD',
            'impressions': productArr
          }
        })
      // sends product list view event to psyhke  
      const urlRouteTracking = JSON.parse(localStorage.getItem("psykhe-plp") || "{}");
      if (!urlRouteTracking[collectionName]) {
        // sends product list view event to psyhke  
        //if user is logged in then send user id else send null
        if(logUser?.userLoggedIn?.id){
          sendProductListViewEvent(collectionName, productArr, recoId, logUser?.userLoggedIn?.id);
          urlRouteTracking[collectionName] = true;
          localStorage.setItem("psykhe-plp", JSON.stringify(urlRouteTracking));
        }
        else{
          sendProductListViewEvent(collectionName, productArr, recoId, null);
          urlRouteTracking[collectionName] = true;
          localStorage.setItem("psykhe-plp", JSON.stringify(urlRouteTracking));
        }
      }
    }
  }

  if (isClient) {
    sendImpression();
  }

  // Restore scroll position after returning from PDP
  useEffect(() => {
    let scrollData = window.history.state?.plpScroll;
    if (!scrollData) {
      const sessionData = sessionStorage.getItem("plp-scroll-data");
      if (sessionData) scrollData = JSON.parse(sessionData);
    }
    if (scrollData && typeof scrollData.scrollY === "number") {
      setTimeout(() => {
        window.scrollTo({ top: scrollData.scrollY, behavior: "auto" });
      }, 0);
      // Optionally clear after restoring
      sessionStorage.removeItem("plp-scroll-data");
      window.history.replaceState({ ...window.history.state, plpScroll: null }, "");
    }
  }, [injectedHits]);

  const renderHits = () => {
    return (
      <>
        {injectedHits.map(({ props, type, Hit }, index) => {
          props.itemkey = index;
          // Add the position and queryId for the click event
          let pos;
            if(currentPage===1){
              if(index<=position1){
                pos=index+1;
              } else if(index>position1 && index<=position2){
                pos=index;
              } else {
                pos=index-1;
              }
            }else{
              pos=(index-1+(currentPage-1)*104);
            }
            props.hit = {
              ...props.hit,
              __position: pos,
              __queryID: results.queryID
            }
          const data = props.hit;
          return (
            <li
              key={index}
              className={["ais-InfiniteHits-item", type].join(" ")}
              onClick={() => {
                // Save scroll position and product ID in history.state and sessionStorage
                if (typeof window !== "undefined" && props?.hit?.id) {
                  const scrollData = {
                    scrollY: window.scrollY,
                    productId: props.hit.id
                  };
                  window.history.replaceState({ ...window.history.state, plpScroll: scrollData }, "");
                  sessionStorage.setItem("plp-scroll-data", JSON.stringify(scrollData));
                }
                console.log(data,"algolia data");
                console.log(data.__position,"algolia data poss");
                if(!data.__position){
                  data.__position = rand(1, 1000);
                }
                sendEvent('click', data, 'Product Clicked');
              }}
              id={`product-item-plp-${props?.hit?.id}`}
            >
              <Hit {...props} />
            </li>
          );
        })}
      </>
    )
  }

  return (
    <div className="ais-InfiniteHits">
      <ol className="ais-InfiniteHits-list">
        <>
          {renderHits()}
        </>
      </ol>

      {/* render the show more button if its a mobile device */}
      {/* {isRequestingFromMobile && totalFetchedSoFar.length > 0 && totalFetchedSoFar.length < totalFetchedProducts ?
        (
          <div style={{ display: 'flex', justifyContent: "center" }}>
            <button
              className="ais-InfiniteHits-loadMore hit-loadMore-btn  mb-0"
              style={{ color: "#2f2f30" }}
              onClick={() => {
                showMore()
              }}
              disabled={isLastPage || totalFetchedSoFar.length < currentPage * (isOnlyMobile ? 50 : 100)}
            >
              <span className="loadmore-txt x-small-xs">Load More</span>
              <div className="loadmore-result">
                <span className="hits-length xxx-small-xs">{totalFetchedSoFar.length} / {totalFetchedProducts} Results</span>
              </div>
            </button>
          </div>
        )
        : <></>
      } */}
    </div >
  );
}
